import React, { Component } from "react";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import TableComp from "../../../components/_utils/table";
import { connect } from "react-redux";
import moment from "moment";
import { Card, Col, Row, Button, Select, DatePicker, notification, Tooltip, Drawer } from "antd";
import common from '../../common.less'
import rightAuth from '../../../components/_utils/userRights'
import Request, { MEDIA_URL } from "../../../request";
import _ from 'lodash'
import LatestFollowup from "../../../components/_utils/latestFollowup";
import PDFFileView from "../../../components/DocumentViews/PDFFileView";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const Option = Select.Option

const { RangePicker } = DatePicker

class UpdateFinanceClaimStatus extends Component {
  state = {
    visible: true
  }

  onClose = () => {
    this.setState({
      visible: false
    }, () => {
      this.props.onClose();
    })
  }


  render() {
    let { visible } = this.state;
    return (
      <Drawer
        title={
          <div>
            <React.Fragment>
              Update Status
            </React.Fragment>
          </div>
        }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={800}
        visible={visible}>
        <Card></Card>
      </Drawer>
    )
  }
}





class AllFinanceClaim extends Component {
  state = {
    count: 0,
    invoiceStatusList: ['Generated', 'Submitted to Uni', 'Approved by Uni', 'Paid by Uni', "Cleared/Paid to Associates"],
    invoiceStatus: '',
    exportParams: {},
    ext: null,
    linkUrl: null,
    branchInvoice: null,
    invoiceId: null,
    showUpdateInvoiceStatusDrawer: false
  }
  constructor(props) {
    super(props);
    this.table = React.createRef();
  }

  exportExcel = async () => {
    let params = this.state.exportParams
    let x = await Request.exportFinanceExcelToExcel({
      ...params,
      regExFilters: ['name']
    })
    if (!x.error) {
      window.open(x.url)
    }
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      if (!params.sortField) {
        params.sortField = 'visaApprovalDate'
        params.sortOrder = 'descend'
      }

      if (this.state.invoiceStatus) {
        params.invoiceClearanceStatus = [this.state.invoiceStatus];
      }
      if (this.state.time) {
        params.visaApprovalDate = this.state.time
      }

      this.setState({ exportParams: params });
      let data = await Request.getAllFinanceClaims({
        ...params,
        regExFilters: ['studentName', 'passportNumber', 'collegeStudentId', 'branch', 'associateOrBranchName', 'cpName', 'invoiceNumber', 'college', 'courseName', 'searchTextName']
      });
      this.setState({ count: data.total })
      resolve(data)
    })
  }
  chooseRangerPickerApplicationDesk = (date, dateString) => {
    this.setState(
      {
        time: {
          from: date[0],
          to: date[1]
        }
      }, () => {
        if (date[0] === undefined) {
          this.table.current.reload()
        }
      }
    )
  }

  loadAllGeneratedInvoices = async (params) => {
    let response = await Request.generatedInvoicesList(params)
  }

  componentDidMount() {
    // this.loadAllGeneratedInvoices()
  }

  closeUpdateInvoiceDrawer = () => {
    this.setState({ showUpdateInvoiceStatusDrawer: false, invoiceId: null });
  }

  onOk = value => {
    this.table.current.reload()
  }

  checkUrlExt = (url) => {
    return url.split(/[#?]/)[0].split('.').pop().trim();
  }

  viewPDF = (branchInvoice) => {
    console.log(branchInvoice);
    if (branchInvoice.length > 0) {
      let linkUrl = MEDIA_URL + branchInvoice[0].url;
      let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
      if (this.checkUrlExt(linkUrl)) {
        this.setState({ ext: ext, linkUrl: linkUrl, branchInvoice: branchInvoice });
      } else {
        notification.warning({
          message: 'File  not exists!!!.'
        })
      }
    }
  }


  updateApBranchInvoiceStatus = (recordId) => {
    this.setState({ invoiceId: recordId, showUpdateInvoiceStatusDrawer: true });
  }

  closePDFDocument = () => {
    this.setState({ ext: null, linkUrl: null, branchInvoice: [] });
  }

  render() {
    let { invoiceStatusList, linkUrl, ext, branchInvoice, showUpdateInvoiceStatusDrawer, invoiceId } = this.state;
    const currencySymbols = {
      USD: "$",      // US Dollar
      EUR: "€",      // Euro
      GBP: "£",      // British Pound
      INR: "₹",      // Indian Rupee
      AUD: "A$",     // Australian Dollar
      CAD: "C$",     // Canadian Dollar
      JPY: "¥",      // Japanese Yen
      CNY: "¥",      // Chinese Yuan
      NZD: "NZ$",    // New Zealand Dollar
      CHF: "CHF",    // Swiss Franc
      SGD: "S$",     // Singapore Dollar
      HKD: "HK$",    // Hong Kong Dollar
      SEK: "kr",     // Swedish Krona
      NOK: "kr",     // Norwegian Krone
      DKK: "kr",     // Danish Krone
      ZAR: "R",      // South African Rand
      AED: "د.إ",    // UAE Dirham
      SAR: "﷼",     // Saudi Riyal
      THB: "฿",      // Thai Baht
      MYR: "RM",     // Malaysian Ringgit
      IDR: "Rp",     // Indonesian Rupiah
      KRW: "₩",      // South Korean Won
      TRY: "₺",      // Turkish Lira
      RUB: "₽",      // Russian Ruble
      BRL: "R$",     // Brazilian Real
      MXN: "$",      // Mexican Peso
      PHP: "₱",      // Philippine Peso
      PLN: "zł",     // Polish Zloty
      HUF: "Ft",     // Hungarian Forint
      CZK: "Kč",     // Czech Koruna
    };
    let columns = [
      {
        title: 'VISA Date',
        key: 'visaDate',
        dataIndex: 'visaApprovalDate',
        searchTextName: `${dateFormat}`,
        sorter: true,
        width: 100,
        render: (item, record) => {
          return (<div>{record.visaApprovalDate ? moment(record.visaApprovalDate).format(dateFormat) : "NA"}</div>)
        }
      },
      {
        title: 'VID',
        key: 'visionId',
        dataIndex: 'visionId',
        searchTextName: 'visionId',
        width: 90
      },
      {
        title: 'Student Name',
        key: 'studentName',
        dataIndex: 'studentName',
        searchTextName: 'studentName',
        sorter: true,
        width: 120
      },
      {
        title: 'PPT',
        key: 'passportNumber',
        dataIndex: 'passportNumber',
        searchTextName: 'passportNumber',
        width: 95
      },
      {
        title: 'DOB',
        key: 'dob',
        dataIndex: 'dob',
        searchTextName: `${dateFormat}`,
        width: 100,
        render: (item, record) => {
          return (<div>{record.dob ? moment(record.dob).format(dateFormat) : "N/A"}</div>)
        }
      },
      {
        title: 'Student ID (Institute)',
        key: 'collegeStudentId',
        dataIndex: 'collegeStudentId',
        searchTextName: 'collegeStudentId',
        width: 120
      },
      {
        title: 'Branch / Associate Partner',
        key: 'branchOrAssociate',
        dataIndex: 'associateOrBranchName',
        searchTextName: 'Branch / Associate Partner',
        sorter: true,
        width: 150,
        render: (_, record) => {
          return record.associateOrBranchName || record.branch || "-";
        }
      },
      {
        title: 'Branch / AP Firm',
        key: 'firmName',
        dataIndex: 'firmName',
        searchTextName: 'Branch / AP Firm',
        sorter: true,
        width: 150,
        render: (_, record) => {
          return record.firmName || "-";
        }
      },
      // {
      //   title: 'Branch',
      //   key: 'branch',
      //   dataIndex: 'branch',
      //   searchTextName: 'branch',
      //   sorter: true,
      //   width: 110,
      //   render: (text, record) => (
      //     <div></div>
      //   )
      // },
      // {
      //   title: "Associate Partner",
      //   key: 'associateOrBranchName',
      //   dataIndex: 'associateOrBranchName',
      //   searchTextName: 'associateOrBranchName',
      //   sorter: true,
      //   width: 120
      // },
      {
        title: 'Channel Partner',
        key: "cpName",
        dataIndex: 'cpName',
        searchTextName: 'cpName',
        sorter: true,
        width: 120,
        render: (item, record) => {
          return (<div>{item ? item : 'Direct'}</div>)
        }
      },
      // {
      //   title: 'Group Name',
      //   key: 'collegeGroupName',
      //   dataIndex: 'collegeGroupName',
      //   sorter: true,
      //   width: 120
      // },
      {
        title: 'College',
        key: 'college',
        dataIndex: 'college',
        searchTextName: 'college',
        sorter: true,
        width: 130
      },
      {
        title: 'Course',
        key: 'courseName',
        dataIndex: 'courseName',
        searchTextName: 'courseName',
        sorter: true,
        width: 150
      },
      {
        title: "Intake",
        key: 'intake',
        dataIndex: 'intake',
        sorter: true,
        width: 90,
        render: (item, record) => {
          return (<div>{record.intake ? moment(record.intake).format('MMM-YYYY') : "N/A"}</div>)
        }
      },
      {
        title: 'Start Date',
        key: 'courseStartDate',
        dataIndex: 'courseStartDate',
        searchTextName: `${dateFormat}`,
        sorter: true,
        width: 90,
        render: (item, record) => {
          return (<div>{record.courseStartDate ? moment(record.courseStartDate).format(dateFormat) : "N/A"}</div>)
        }
      },
      {
        title: "Term Number",
        key: 'termNumber',
        dataIndex: "termNumber",
        searchTextName: `Term Number Only`,
        sorter: true,
        width: 100,
        render: (text, item) => {
          return (<div>Term-{item.termNumber}</div>)
        }
      },

      {
        title: "Country",
        key: 'country',
        dataIndex: "country",
        searchTextName: "country",
        sorter: true,
        width: 110
      },
      {
        title: "Invoice Number",
        key: 'invoiceNumber',
        dataIndex: "invoiceNumber",
        searchTextName: 'invoiceNumber',
        sorter: true,
        width: 130
      },
      {
        title: "Invoice Date",
        key: 'invoiceGenerationDate',
        dataIndex: "invoiceGenerationDate",
        searchTextName: `${dateFormat}`,
        width: 90,
        render: (text, item) => {
          return (<div>{item.invoiceGenerationDate ? moment(item.invoiceGenerationDate).format(dateFormat) : "N/A"}</div>)
        }
      },
      {
        title: "Currency",
        key: 'currency',
        dataIndex: "currency",
        searchTextName: `Currency`,
        width: 70
      },
      {
        title: "Tution Fee Paid",
        key: 'claimableTutionFee',
        dataIndex: "claimableTutionFee",
        searchTextName: `Tution Fee Paid`,
        width: 90,
        render: (text, record) => (
          <div>{currencySymbols[record.currency]}{text}</div>
        )
      },
      {
        title: "%Age",
        key: 'commissionAmount',
        dataIndex: "commissionAmount",
        searchTextName: "%Age",
        width: 60,
        render: (text, item) => {
          return (<div>{item.commissionAmount ? item.commissionAmount : item.commissionAmount} {item.commissionType == 'Percentage' ? '%' : 'Flat'}</div>)
        }
      },
      {
        title: "Invoice Amount",
        key: 'invoiceAmount',
        dataIndex: "invoiceAmount",
        searchTextName: "Invoice Amount",
        width: 70,
        render: (text, record) => {
          let value = record.invoiceAmount && record.invoiceAmount > 0 ? record.invoiceAmount.toFixed(2) : 0;
          return (
            <div>{currencySymbols[record.currency]}{value}</div>
          )
        }
      },

      {
        title: 'Conversion Rate (ARP)',
        key: 'conversionRate',
        searchTextName: "Conversion Rate",
        width: 100,
        render: (text, record) => (
          <div>{currencySymbols['INR']}{text}</div>
        )
      },
      // {
      //   title: 'INR Received',
      //   key: 'inrReceived',
      //   width: 110,
      // },

      {
        title: "Commission Received",
        key: "commissionAmountReceived",
        dataIndex: "commissionAmountReceived",
        searchTextName: "Commission Received",
        width: 90,
        render: (value, record) => {
          const symbol = currencySymbols['INR'] || "";
          if (!value) return `${symbol}0.00`;
          return `${symbol}${Number(value).toFixed(2)}`;
        }
      },
      {
        title: "Bank",
        key: 'bank',
        dataIndex: "bank",
        searchTextName: "Receiving Bank",
        width: 90
      },
      {
        title: "Commission Received Date",
        key: 'commissionReceivingDate',
        dataIndex: "commissionReceivingDate",
        searchTextName: `${dateFormat}`,
        width: 90,
        render: (record, item) => {
          return (<div>{item.commissionReceivingDate ? moment(item.commissionReceivingDate).format(dateFormat) : "N/A"}</div>)
        }
      },

      {
        title: "AP/Branch Share",
        key: 'apOrBranchSharePercentange',
        dataIndex: "apOrBranchSharePercentange",
        searchTextName: 'AP/Branch Share',
        width: 90,
        render: (item, record) => {
          return (<div>{item}</div>)
        }
      },
      {
        title: "AP/Branch Amount",
        key: "apOrBranchAmount",
        dataIndex: "apOrBranchAmount",
        searchTextName: "AP/Branch Amount",
        width: 90,
        render: (value, record) => {
          // ✅ If conversionRate exists → use record.currency, else INR
          const currencyKey = record.conversionRate ? "INR" : record.currency;
          const symbol = currencySymbols[currencyKey] || "";

          return (
            <div>
              {record.apOrBranchAmount
                ? `${symbol}${record.apOrBranchAmount.toFixed(2)}`
                : `${symbol}0.00`}
            </div>
          );
        },
      },
      {
        title: "AP/Branch Inv No/Date",
        key: "apOrBranchInvNumber",
        dataIndex: "apOrBranchInvNumber",
        width: 90,
        searchTextName: 'AP/Branch Inv No/Date',
        render: (item, record) => {
          const date = record.apOrBranchInvDate
            ? moment(record.apOrBranchInvDate).format(dateFormat)
            : "N/A";

          return (
            <div>
              {record.apOrBranchInvNumber ? (
                <a
                  onClick={() => this.viewPDF(record.apOrBranchInvoice)}
                  style={{ cursor: "pointer", color: "#1890ff" }}
                >
                  {record.apOrBranchInvNumber}
                </a>
              ) : null}
              {record.apOrBranchInvNumber ? " / " : ""} {date}
            </div>
          );
        },
      },
      {
        title: "AP/Branch Comm Status",
        key: 'apOrBranchInvoiceStatus',
        dataIndex: "apOrBranchInvoiceStatus",
        width: 90,
        filters: [
          { text: 'Pending', value: 'Pending' },
          { text: 'Paid', value: 'Paid' },
        ]
      },
      {
        title: "Invoice Status",
        key: 'invoiceClearanceStatus',
        dataIndex: "invoiceClearanceStatus",
        filters: [
          { value: 'Generated', text: 'Generated' },
          { value: 'Submitted to Uni', text: 'Submitted to Uni' },
          { value: 'Approved by Uni', text: 'Approved by Uni' },
          { value: 'Paid by Uni', text: 'Paid by Uni' },
          { value: 'Cleared', text: 'Cleared/Paid to Associates' },
        ],
        width: 90,
        render: (text, item) => {
          return (<div>{item.invoiceClearanceStatus}</div>)
          // return (<div className={item.invoiceClearanceStatus}>{item.invoiceClearanceStatus == 'Generated' ? 'Inv to be processed' : item.invoiceClearanceStatus}</div>)
        }
      },
      {
        title: 'Follow Up',
        key: 'followUp',
        width: 120,
        render: (text, record) => {
          return (
            <LatestFollowup info={record.inquiryId && record.inquiryId.paymentFollowUp ? record.inquiryId.paymentFollowUp : null} />
          )
        }
      },
      // {
      //   title: "Financial Year",
      //   key: 'financialYear',
      //   dataIndex: "financialYear",
      //   width: 120,
      //   render: (_, record) => {
      //     const createdDate =
      //       record && record.createdByUser &&
      //       record.createdByUser.time &&
      //       record.createdByUser.time.$date;

      //     if (!createdDate) return "-";

      //     const dateObj = new Date(createdDate);
      //     const year = dateObj.getFullYear();
      //     const month = dateObj.getMonth() + 1; // JS months are 0-based

      //     // Financial year in India: April (4) → March (3)
      //     const startYear = month >= 4 ? year : year - 1;
      //     const endYear = startYear + 1;

      //     return startYear + "-" + endYear;
      //   }
      // },





      // {
      //   title:'Notes',
      //   key:'notes',
      //   dataIndex:'notes',
      //   width:90
      // },
      // {
      //   title:'Note Date',
      //   key:'noteDate',
      //   dataIndex:'noteDate',
      //   width:90,
      //   render:(item,record)=>{
      //     return (<div>{record.noteDate?moment(record.noteDate).format(dateFormat):"N/A"}</div>)
      //   }
      // },
      // {
      //   title:'Commission Contact Person',
      //   key:'commissionContactPerson',
      //   dataIndex:'commissionContactPerson',
      //   width:110
      // },
      // {
      //   title:'Contact Person Email',
      //   key:'contactPersonEmail',
      //   dataIndex:'contactPersonEmail',
      //   width:110
      // },
      // {
      //   title:'Contact Person Number',
      //   key:'contactPersonNumber',
      //   dataIndex:'contactPersonNumber',
      //   width:110
      // }
    ]

    return (
      <PageHeaderWrapper
        title={` Student Record Sheet: ${this.state.count} `}
      >
        <Card bordered={true}>
          {
            ext != null && branchInvoice.length > 0 ?
              <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closePDFDocument} />
              : null
          }
          {
            showUpdateInvoiceStatusDrawer ?
              <UpdateFinanceClaimStatus onClose={this.closeUpdateInvoiceDrawe} />
              : null
          }
          <Row>
            <Col span={8}>
              <label>Filter by Visa Date</label><br />
              <RangePicker
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD"
                placeholder={['Start Date', 'End Date']}
                onChange={this.chooseRangerPickerApplicationDesk}
                onOk={this.onOk}
              />
            </Col>
            <Col span={8}>
              <label>Filter By Invoice Status</label>
              <Select
                allowClear
                style={{
                  width: 225,
                  marginRight: 16
                }}
                showSearch={true}
                className={common.width100Pr}
                value={this.state.invoiceStatus}
                placeholder="Select Option"
                optionFilterProp="display"
                onChange={invoiceStatus => {
                  this.setState(
                    {
                      invoiceStatus
                    },
                    () => {
                      setTimeout(() => {
                        this.table.current.reload()
                      }, 500);
                    }
                  );
                }}>
                {invoiceStatusList.map((val, idn) => {
                  return (
                    <Option key={idn} value={val}>
                      {val}
                    </Option>
                  )
                })}
              </Select>
            </Col>
            <Col span={4}>

            </Col>

          </Row>
          <TableComp id={"allfinanceclaims"}
            showSelector={true}
            columns={columns}
            extraProps={{ scroll: { x: 1800 } }}
            ref={this.table}
            apiRequest={(params) => this.apiRequest(params, columns)}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 100,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }} />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllFinanceClaim);
